import { useEffect, useCallback } from 'react';

declare global {
	interface Window {
		grecaptcha: any;
	}
}

export function useRecaptchaV3(siteKey: string) {
	useEffect(() => {
		if (!siteKey) return;
		const loadScript = () => {
			if (document.querySelector(`script[src*="recaptcha/api.js"]`)) return;

			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
		};

		loadScript();
	}, [siteKey]);

	const executeRecaptcha = useCallback(
		async (action: string, inputId: string): Promise<string | null> => {
			if (!window.grecaptcha || !window.grecaptcha.execute) {
				return null;
			}

			return new Promise((resolve, reject) => {
				window.grecaptcha.ready(() => {
					window.grecaptcha
						.execute(siteKey, { action })
						.then((token: string) => {
							resolve(token);
						})
						.catch(reject);
				});
			});
		},
		[siteKey]
	);

	return { executeRecaptcha };
}
